module.exports = __webpack_public_path__ + "static/media/sabah & sarawak.d3d64ca8.png";